/* Add-on-Bild je Holzart fuer den Warenkorb (24.09.2026).
   Konfigurator A (desk-con-apple), Konfigurator B (desk-con-apple-b) und die
   Kaufbox (edelholz-pdp-minikonfigurator) legen Add-ons in den Warenkorb. Damit
   dort das Add-on in der gewaehlten Holzart erscheint statt im Golden-Timber-
   Produktbild, bekommt jedes Add-on-Item zwei unsichtbare Properties:
     _bild   = cdn.shopify.com-URL des Renderings in dieser Holzart (width=360)
     _finish = Name der Holzart, z. B. "Smoked Amber"
   snippets/line-item.liquid zeigt _bild statt des Produktbilds.

   Quelle: der JSON-Block aus snippets/edelholz-finish-bilder-daten.liquid
   (dieselbe Tabelle, aus der B und Kaufbox ihre Kartenbilder tauschen).
   Nur wenn fuer GENAU diese Holzart eine Datei eingetragen ist, gibt es
   Properties. Kein Golden-Timber-Ersatz, kein asset:-Bild, keine Tabellenzeile
   (z. B. Monitorarm) = null, dann bleibt im Warenkorb das Produktbild.

   Aufruf: EHAddonBild.props(quelle, finish, daten)
     quelle  Bild-URL, die die Karte gerade zeigt (Rohdatei oder schon getauscht),
             oder "motiv:<schluessel>" (Kaufbox traegt das Motiv am <img>).
     finish  state.finish der Section.
     daten   optional das schon geparste JSON der Section; sonst liest das
             Skript den Block [data-eh-fbild-daten] selbst.
   Rueckgabe: { _bild, _finish, Finish } (jeweils nur, wenn zutreffend) oder null. Wirft nie.

   30.09.2026 (Kasse): Das Bild in Shopifys Kasse ist nicht aenderbar und zeigt immer
   das Golden-Timber-Produktbild. Darum bekommt jedes Add-on, das in Holz gefertigt
   wird, zusaetzlich die SICHTBARE Property
     Finish = "Smoked Amber (wie dein Tisch)"
   (gleicher Key wie am Tisch, Philipp 30.09.). Sie erscheint in Kasse, Bestell-
   bestaetigung und Bestellung. Holz-Add-on = Motiv beginnt mit einem Eintrag aus
   HOLZ_MOTIVE (CableSLOT, CenterDRAW, SideDRAW, PowerPORT, SmartCHARGE, SoftGLOW).
   PowerLINK (Aluminium), Monitorarme, Stuehle und alles ohne Motiv bekommen keine
   Finish-Zeile. Unabhaengig davon, ob es schon ein Rendering in dieser Holzart gibt,
   also auch bei Golden Timber. Der Zusatz "(wie dein Tisch)" unterscheidet die Zeile
   vom Tisch-Finish: Leser, die "Finish" am Tisch suchen, erkennen den Tisch am Handle
   bzw. _eh_gruppe/Modell, nie an "Finish" allein (Stand 30.09., Theme + VPS geprueft).
   Aufrufer ohne sicher bekannte Tisch-Holzart geben als 4. Argument { holz: false } mit,
   dann gibt es keine Finish-Zeile (nur _bild/_finish wie bisher).
   snippets/line-item.liquid blendet diese Zeile im eigenen Warenkorb aus, wenn _bild die
   Holzart schon zeigt. */
(function () {
  var cache = null;
  function daten(d) {
    if (d && d.motive) return d;
    if (cache) return cache;
    try {
      var el = document.querySelector('[data-eh-fbild-daten]');
      cache = el ? JSON.parse(el.textContent) : null;
    } catch (e) { cache = null; }
    return cache;
  }
  function slug(t) {
    return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function datei(u) {
    return String(u || '').split('?')[0].split('/').pop().toLowerCase();
  }
  /* Motiv zu einer URL: erst die heutige Datei, dann die Holzart-Renderings
     (falls die Karte schon getauscht zeigt). */
  function motivZu(d, quelle) {
    var q = String(quelle || '').trim();
    if (!q) return null;
    if (q.indexOf('motiv:') === 0) return q.slice(6).trim() || null;
    var n = datei(q);
    if (!n) return null;
    var m = (d.datei2motiv || {})[n];
    if (m) return m;
    for (var k in d.motive) {
      var z = d.motive[k];
      for (var s in z) {
        if (s !== 'heute' && z[s] && datei(z[s]) === n) return k;
      }
    }
    return null;
  }
  function mitBreite(u, b) {
    var x = String(u).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return x + (x.indexOf('?') > -1 ? '&' : '?') + 'width=' + b;
  }
  /* Motive von Add-ons, die in der Holzart des Tisches gefertigt werden (30.09.).
     Bewusst NICHT: powerlink* (Aluminium), vergleich-*, groessentabelle-*, kabel*-Features. */
  var HOLZ_MOTIVE = /^(cableslot|centerdraw|sidedraw|kabeldurchlass-seitlich-arc-schublade|powerport|smartcharge|softglow)(-|$)/;
  /* 02.10.26 SaphirSHIELD: die Blende ist immer Graphitschwarz, die Holzart bestimmt nur Bild und Zuordnung.
     Darum NICHT "Finish: <Holz> (wie dein Tisch)", sondern sichtbar "Passend zu: <Holz>" + "Farbe". Gilt auch ohne
     bekannten Tisch (Add-on-Seite: die Holzart waehlt der Kunde dort selbst). */
  var PASSEND_MOTIVE = /^saphirshield(-|$)/;
  var PASSEND_FARBE = 'Graphitschwarz RAL 9011 seidenmatt';
  window.EHAddonBild = {
    props: function (quelle, finish, d0, opt) {
      try {
        var d = daten(d0);
        if (!d || !d.motive || !quelle || !finish) return null;
        var motiv = motivZu(d, quelle);
        var zeile = motiv && d.motive[motiv];
        if (!zeile) return null;
        var o = null;
        var fin = String(finish).trim();
        if (fin && HOLZ_MOTIVE.test(motiv) && !(opt && opt.holz === false)) o = { Finish: fin + ' (wie dein Tisch)' };
        if (fin && PASSEND_MOTIVE.test(motiv)) o = { 'Passend zu': fin, Farbe: PASSEND_FARBE };
        var f = zeile[slug(finish)];
        if (!f || f.indexOf('asset:') === 0) return o;
        var url = (d.cdn || '') + f;
        if (url.indexOf('https://cdn.shopify.com/') !== 0) return o;
        o = o || {};
        o._bild = mitBreite(url, 360);
        o._finish = String(finish);
        return o;
      } catch (e) {
        return null;
      }
    }
  };
})();

/* Lesbare Konfiguration fuer Kasse, Bestellbestaetigung und Kundenkonto (25.09.2026).
   Shopify zeigt dort jede Property ohne Unterstrich 1:1. Darum schreiben die drei
   Konfiguratoren die Rohform nur noch versteckt mit und die sichtbaren Keys lesbar:
     _eh_features  Rohform wie bisher "seitlicher Kabeldurchlass: rechts | oberer ..."
     _eh_addons    Rohform wie bisher "CableSLOT(rechts)|SoftGLOW(deskpro/deskpure)|..."
     je Feature ein eigener Key, z. B. "Seitlicher Kabeldurchlass": "Rechts"
       (so liest der Auftrags-Abgleich auf dem VPS die Kabeldurchlaesse bereits,
       lib/finance/auftrags-abgleich.ts, Pfad "eigene Properties am Tisch")
     "Add-ons"     "CableSLOT Rechts, SoftGLOW, PowerLINK Gold eloxiert"
       (Kompatibilitaets-Klammern wie deskpro/deskpure oder ein Modellname fallen
       weg, echte Wahlen kommen mit dem Label aus den Block-Choices "wert|Label|id").
   snippets/line-item.liquid liest fuer die Gruppen _eh_features/_eh_addons.
   Aufruf: EHProps.lesbar(featuresRoh, addonsRoh, bloecke) -> Objekt, wirft nie. */
(function () {
  function gross(s) { s = String(s || '').trim(); return s.charAt(0).toUpperCase() + s.slice(1); }
  /* 25.09.: Rohwert "zentriert" bleibt (_eh_features, Draft-Order), sichtbar heisst er "Mittig".
     VPS lib/finance/auftrags-abgleich.ts side() kennt bisher nur /zentriert/. */
  var ANZ = { zentriert: 'mittig' };
  var MODELL = /^(deskpure|deskpro|arcpure|studiopure|loungepure|shelfpure)$/i;
  function label(bloecke, name, wert) {
    var l = '';
    (bloecke || []).forEach(function (b) {
      var s = b && b.settings;
      if (l || !s || String(s.title || '').trim() !== name) return;
      String(s.choices || '').split('\n').forEach(function (z) {
        var t = z.split('|');
        if (!l && t.length > 1 && t[0].trim() === wert) l = t[1].trim();
      });
    });
    return l;
  }
  window.EHProps = {
    lesbar: function (fRoh, aRoh, bloecke) {
      var o = {};
      try {
        String(fRoh || '').split('|').forEach(function (t) {
          var i = t.indexOf(':');
          var k = (i > -1 ? t.slice(0, i) : t).trim();
          var v = i > -1 ? t.slice(i + 1).trim() : 'true';
          if (!k || !v || v === 'false') return;
          o[gross(k)] = v === 'true' ? 'Ja' : gross(ANZ[v] || v);
        });
        var liste = [];
        String(aRoh || '').split('|').forEach(function (t) {
          t = t.trim();
          if (!t) return;
          var m = t.match(/^([^(]+?)\s*(?:\((.*)\))?$/);
          var name = (m ? m[1] : t).trim();
          var wahl = m && m[2] ? m[2].trim() : '';
          if (wahl && (wahl.indexOf('/') > -1 || MODELL.test(wahl))) wahl = '';
          if (wahl) wahl = label(bloecke, name, wahl) || gross(wahl);
          liste.push(wahl ? name + ' ' + wahl : name);
        });
        if (liste.length) o['Add-ons'] = liste.join(', ');
      } catch (e) {}
      if (fRoh) o._eh_features = String(fRoh);
      if (aRoh) o._eh_addons = String(aRoh);
      return o;
    }
  };
})();
